import { MouseEvent } from "react";

const POPUP_SCREEN_RATIO = 0.6;

export const openPopupWithParams = (event: MouseEvent, SchemeIdBindObject: number) => {
  const popupWidth = Math.max(1, Math.round(window.screen.width * POPUP_SCREEN_RATIO));
  const popupHeight = Math.max(1, Math.round(window.screen.height * POPUP_SCREEN_RATIO));
  const x = Math.min(Math.max(0, event.screenX), Math.max(0, window.screen.width - popupWidth));
  const y = Math.min(Math.max(0, event.screenY), Math.max(0, window.screen.height - popupHeight));

  const newUrl = new URL(window.location.href);
  newUrl.searchParams.delete("stationId");
  newUrl.searchParams.delete("component");
  newUrl.searchParams.set("trainId", String(SchemeIdBindObject));
  newUrl.searchParams.set("tab", "1");
  newUrl.searchParams.set("onlyPage", "true");

  window.open(
    newUrl.toString(),
    "_blank",
    `width=${popupWidth},height=${popupHeight},left=${x},top=${y},resizable=yes,scrollbars=yes`,
  );
};
